import React from 'react';
import PostCard from './PostCard';

function PostList({ posts }) {
  // Sort posts by id in descending order
  const sortedPosts = [...posts].sort((a, b) => b.id - a.id);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {sortedPosts.map(post => (
        <PostCard key={post.id} post={post} />
      ))}
    </div>
  );
}

export default PostList;